import { JSX } from "react";

import { Outlet } from "react-router-dom";

function CenterRegionDashboardPage(): JSX.Element {
  return <Outlet />;
}

export default CenterRegionDashboardPage;
